import { AppRoutes } from '@constants';

/** Routes whose query string carries secrets (the reset token) and never reaches GA. */
const ROUTES_WITHOUT_QUERY: string[] = [`/${AppRoutes.CREATE_NEW_PASSWORD}`];

/** Drops the query string and fragment on routes listed in ROUTES_WITHOUT_QUERY. */
export function toTrackedPath(url: string): string {
  const path = url.split(/[?#]/)[0];
  return ROUTES_WITHOUT_QUERY.includes(path) ? path : url;
}
